import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.manage.config', {
        url: '/config',
        component: 'companyIdpAuthenticatorsManageConfig',
        resolve: {
        },

    });
}





// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/config/idp-authenticator-config.state.js